import React from 'react';
import {IonCol, IonGrid, IonRow, IonSkeletonText} from "@ionic/react";
import {StyledInvitation} from "../planningTab.style";

const InvitationSkeleton: React.FC = () => {
    return (
        <StyledInvitation>
            <IonGrid>
                <IonRow>
                    <IonCol size="12" class="invitation-title">
                        <IonSkeletonText animated style={{ width: (Math.random()>=0.5) ? '70%' : '50%' }} />
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size="12" class="content">
                        <div className="place">
                            <IonSkeletonText animated style={{ width: '95%' }} />
                        </div>
                        <div className="date">
                            <IonSkeletonText animated style={{ width: '95%' }} />
                        </div>
                        <div className="contractor">
                            <IonSkeletonText animated style={{ width: '95%' }} />
                        </div>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size="12">
                        <div className="status-title border">
                            <IonSkeletonText animated style={{ width: '50%' }} />
                        </div>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size="12">
                        <div className="members">
                            <IonSkeletonText animated style={{ width: '50%' }} />
                        </div>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size="12">
                        <div className="status-title">
                            <IonSkeletonText animated style={{ width: '50%' }} />
                        </div>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size="12">
                        <div className="members">
                            <IonSkeletonText animated style={{ width: '50%' }} />
                        </div>
                    </IonCol>
                </IonRow>
            </IonGrid>
        </StyledInvitation>
    );
};

export default InvitationSkeleton;
